"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortCodeStringToObject = function (sortCode) {
    var sortCodeSplit = ['', '', ''];
    if (sortCode) {
        var split = sortCode.match(/.{2}/g);
        if (split != null) {
            sortCodeSplit = split;
        }
    }
    return {
        first: sortCodeSplit[0],
        second: sortCodeSplit[1],
        third: sortCodeSplit[2],
    };
};
exports.sortCodeObjectToString = function (sortCode) {
    if (sortCode !== null && typeof sortCode === 'object') {
        return (sortCode.first + sortCode.second + sortCode.third);
    }
    return '';
};
